module.exports = __webpack_public_path__ + "img/login_logo.a3822e70.png";